import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import './styles.scss';

const chips = [
  { label: 'Drawings', to: '/features/drawings' },
  { label: 'RFIs', to: '/features/rfi' },
  { label: 'Submittals', to: '/features/submittals' },
  { label: 'Daily Logs', to: '/features/daily_log' },
  { label: 'Punch Lists', to: '/features/punchlists' },
  { label: 'Locations & Site QR', to: '/features/locations' },
  { label: 'Time Tracking', to: '/features/time_tracking' },
  { label: 'Asset Tracking', to: '/features/asset_tracking' },
  { label: 'Action Items', to: '/features/actions' },
  { label: 'Forms', to: '/features/forms' },
  { label: 'Mobile App · iOS + Android', to: '/features' },
];

export default function ToolkitMarquee() {
  return (
    <section className="plh-toolkit">
      <Reveal className="plh-toolkit__lead">
        <h2>
          The complete toolkit. Included on <span className="plh-accent">every plan.</span>
        </h2>
        <p>
          No modules to license. No add-ons to negotiate. Drawings, RFIs, submittals, daily logs,
          punch, forms, and more — built once, on every plan, with free subcontractor accounts.
        </p>
      </Reveal>
      <div className="plh-toolkit__marquee">
        <div className="plh-toolkit__track">
          {[...chips, ...chips].map((chip, idx) => (
            <Link
              className="plh-toolkit__chip plh-mono"
              to={chip.to}
              key={`${chip.label}-${idx}`}
              tabIndex={idx >= chips.length ? -1 : undefined}
              aria-hidden={idx >= chips.length ? 'true' : undefined}
            >
              {chip.label} <span aria-hidden="true">→</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
